import * as React from 'react';
import { useRoutePath } from 'react-static';
import { formattedDate } from '../../../common/helpers/date';
import { useSiteRoot } from '../../../common/hooks/useSiteRoot';
import { useTranslations } from '../../../common/translation';
import { buildArticleJsonLd } from '../../../components/head-jsonld/buildArticleJsonLd';
import { HeadJsonLd } from '../../../components/head-jsonld/HeadJsonLd';
import { HeadTitle } from '../../../components/head-title/HeadTitle';
import { Img } from '../../../components/img/Img';
import { categoryList } from '../common';
import { useInitializeNews } from '../hooks/useInitializeNews';
import { NewsProps } from '../NewsLayout.props';
import {
  StyledNews,
  StyledNewsContent,
  StyledNewsDate,
  StyledNewsHeader,
  StyledNewsImageContainer,
  StyledNewsSubtitle,
  StyledNewsTitle,
} from '../NewsLayout.styles';
import translations from '../translations';

export const Article = (props: NewsProps) => {
  const { body, categories, date, image, subtitle, timezone, title } = props;
  const { locale, t } = useTranslations(translations);
  const localeDate = typeof date !== 'undefined' ? formattedDate(+date * 1000, locale, 'news', timezone) : '';
  const siteRoot = useSiteRoot();
  const currentPath = useRoutePath('') || '';
  const articleJsonLd = buildArticleJsonLd({ siteRoot, currentPath, newsProps: props });

  useInitializeNews();

  return (
    <StyledNews data-component='article'>
      <HeadTitle title={`${title} | ${t('articlePageTitle', 'Articles')}`} />
      <HeadJsonLd data={articleJsonLd} />
      <StyledNewsHeader>
        {categoryList(categories, t)}
        {localeDate && <StyledNewsDate data-testid='news-date'>{localeDate}</StyledNewsDate>}
        <StyledNewsTitle>{title}</StyledNewsTitle>
        {subtitle && <StyledNewsSubtitle>{subtitle}</StyledNewsSubtitle>}
      </StyledNewsHeader>
      <StyledNewsContent>
        {image && (
          <StyledNewsImageContainer>
            <Img
              alt={image.alt || `${title} - ${t('articleImageAltFallback', 'Banner')}`}
              src={image.src}
              title={image.title}
            />
          </StyledNewsImageContainer>
        )}
        <div dangerouslySetInnerHTML={{ __html: body }} />
      </StyledNewsContent>
    </StyledNews>
  );
};
